import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import SavedSearchSettingsUpsertName from '../SavedSearchSettingsUpsert/fields/SavedSearchSettingsUpsertName';
import SavedSearchSettingsUpsertSearchTerms from '../SavedSearchSettingsUpsert/fields/SavedSearchSettingsUpsertSearchTerms';
import SavedSearchSettingsUpsertCommodityCodes from '../SavedSearchSettingsUpsert/fields/SavedSearchSettingsUpsertCommodityCodes';
import SavedSearchSettingsUpsertLocations from '../SavedSearchSettingsUpsert/fields/SavedSearchSettingsUpsertLocations';
import SavedSearchSettingsUpsertOrganizations from '../SavedSearchSettingsUpsert/fields/SavedSearchSettingsUpsertOrganizations';
import SavedSearchSettingsUpsertStatus from '../SavedSearchSettingsUpsert/fields/SavedSearchSettingsUpsertStatus';
import SavedSearchSettingsUpsertOpportunityTypes from '../SavedSearchSettingsUpsert/fields/SavedSearchSettingsUpsertOpportunityTypes';
import SavedSearchSettingsUpsertOpportunitySource from '../SavedSearchSettingsUpsert/fields/SavedSearchSettingsUpsertOpportunitySource';
import SavedSearchSettingsUpsertViewed from '../SavedSearchSettingsUpsert/fields/SavedSearchSettingsUpsertViewed';

export const useSavedSearchFields = () => {
  const { t } = useTranslation();

  const fields = useMemo(
    () => [
      {
        id: 'name',
        title: t('settings.saved_search.edit_or_create.name_title'),
        description: t('settings.saved_search.edit_or_create.name_description'),
        component: <SavedSearchSettingsUpsertName />,
      },
      {
        id: 'searchTerms',
        title: t('settings.saved_search.edit_or_create.search_terms_title'),
        description: t('settings.saved_search.edit_or_create.search_terms_description'),
        component: <SavedSearchSettingsUpsertSearchTerms />,
      },
      {
        id: 'commodityCodes',
        title: t('settings.saved_search.edit_or_create.commodity_codes_title'),
        description: t('settings.saved_search.edit_or_create.commodity_codes_description'),
        component: <SavedSearchSettingsUpsertCommodityCodes />,
      },
      {
        id: 'locations',
        title: t('settings.saved_search.edit_or_create.locations_title'),
        description: t('settings.saved_search.edit_or_create.locations_description'),
        component: <SavedSearchSettingsUpsertLocations />,
      },
      {
        id: 'organization',
        title: t('settings.saved_search.edit_or_create.organizations_title'),
        description: t('settings.saved_search.edit_or_create.organizations_description'),
        component: <SavedSearchSettingsUpsertOrganizations />,
      },
      {
        id: 'status',
        title: t('settings.saved_search.edit_or_create.status_title'),
        description: t('settings.saved_search.edit_or_create.status_description'),
        component: <SavedSearchSettingsUpsertStatus />,
      },
      {
        id: 'opportunityTypes',
        title: t('settings.saved_search.edit_or_create.opportunity_types_title'),
        description: t('settings.saved_search.edit_or_create.opportunity_types_description'),
        component: <SavedSearchSettingsUpsertOpportunityTypes />,
      },
      {
        id: 'opportunitySource',
        title: t('settings.saved_search.edit_or_create.opportunity_source_title'),
        description: t('settings.saved_search.edit_or_create.opportunity_source_description'),
        component: <SavedSearchSettingsUpsertOpportunitySource />,
      },
      {
        id: 'viewedProjects',
        title: t('settings.saved_search.edit_or_create.viewed_title'),
        description: t('settings.saved_search.edit_or_create.viewed_description'),
        component: <SavedSearchSettingsUpsertViewed />,
      },
    ],
    [t]
  );

  const fieldIds = useMemo(
    () => fields.reduce((acc, { id }) => ({ ...acc, [id]: id }), {}),
    [fields]
  );

  return { fields, fieldIds };
};
